// extracted by mini-css-extract-plugin
export var addButton = "_fh-4";
export var contentBlockImage = "_fh-i";
export var contentBlockWidgetPreview = "_fh-g";
export var fulfillmentCutoffWidgetPreview = "_fh-9";
export var imageBackdrop = "_fh-6";
export var imageIcon = "_fh-8";
export var lowProfileImageContainer = "_fh-b";
export var lowProfileImageIcon = "_fh-f";
export var lowProfileImageIconContainer = "_fh-e";
export var lowProfileImagePlaceholder = "_fh-d";
export var lowProfileProductImage = "_fh-c";
export var lowProfileProductUpsellWidgetPreview = "_fh-a";
export var productCard = "_fh-5";
export var productImage = "_fh-7";
export var productReviewsWidgetPreview = "_fh-h";
export var progressBar = "_fh-1";
export var progressBarFill = "_fh-2";
export var progressBarTrack = "_fh-3";
export var shippingOptionWidgetPreview = "_fh-j";
export var shippingUpsellProgressBar = "_fh-k";
export var thresholdUpsellWidgetPreview = "_fh-0";